import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { formatDateToLocale } from 'utils';

import { useMemo } from 'react';

import { getPriceVersionsGql } from '../bimWorkOrderPriceAnalyticsQueries';

export const useVersionItems = ({ workOrderPriceId }: { workOrderPriceId: number }) => {
    const variables = useMemo(() => ({ workOrderPriceId }), [workOrderPriceId]);

    const [data, status] = useRequest({
        requestId: 'analyticsPriceVersions',
        query: getPriceVersionsGql,
        variables,
    });

    const isLoading = status === RequestStatus.FETCHING;

    return {
        data: (data?.bimWorkOrderPriceRevisions?.items ?? [])
            .map((item) => ({
                id: item.id,
                label: `${item.planValue.code} ${item.priceUpdateDate ? formatDateToLocale(item.priceUpdateDate) : ''}`,
            }))
            .filter((i) => i.label),
        isLoading,
    };
};
